<template>
    <span>
        <button
            type="button"
            @click=toBilling
            class="bg-white border border-blue-300 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 font-medium hover:bg-blue-50 hover:border-blue-400 inline-flex items-center justify-between leading-extra-tight p-2.5 py-0.5 rounded-full shadow-sm space-x-2 text-white text-sm"
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 text-gray-400">
                <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clip-rule="evenodd" />
            </svg>
            <span class="italic font-medium text-gray-700">
                Upgrade to Unlock
            </span>
        </button>
    </span>
</template>

<script>
export default {
    props: {
        modelId: {
            type: Number,
            required: true,
        },
        modelType: {
            type: String,
            required: true,
        },
        attributeName: {
            type: String,
            required: true,
        },
        attributeTitle: {
            type: String,
            required: true,
        },
    },
    data () {
        return {};
    },
    methods: {
        toBilling() {
            window.location = this.route('billing.index');
        }
    }
};
</script>
